module.exports = __webpack_public_path__ + "img/319a03f19334ccd14009fdf4954c4ace.png";